import { useGetPlusData, useGetShow } from './query/show';
import useUserPermission from './useUserPermission';
import { useSetPlusTiers } from './query/episode';
import { useState, useEffect, useMemo } from 'react';

const useAcastPlus = ({ showId, actions = ['read'], states = ['Active'] }) => {
  const { show: showData, isShowLoading: showDataLoading, isShowFetchSuccess } = useGetShow(showId);
  const networkId = showData?.network;
  const hasAcastPlusBYOP = !!showData?.integrations?.customPaywall?.isEnabled;

  const { hasUserAccess, isUserAccessLoading: permissionsLoading } = useUserPermission(
    { appName: 'plus', actions },
    showId,
    networkId,
    showDataLoading || !showData || !isShowFetchSuccess
  );

  const {
    show: showDataPlus,
    tiers: availableTiers,
    hasPegasusError: plusDataError,
    hasPegasusLoading: plusDataLoading,
  } = useGetPlusData(hasUserAccess, showId);

  const [tiers, setTiers] = useState([]);
  const [tierStates, setTierStates] = useState([]);

  useMemo(() => {
    if (!tierStates.length) {
      setTierStates(states);
    }
  }, [states, tierStates]);

  useEffect(() => {
    if (availableTiers) {
      setTiers(availableTiers.filter(({ state }) => tierStates.includes(state)));
    }
  }, [availableTiers, tierStates]);

  const { setEpisodesTiers } = useSetPlusTiers();
  return {
    isEnabled: hasUserAccess && plusDataError?.response?.status !== 404 && showDataPlus?.accepted,
    show: hasUserAccess
      ? plusDataError?.response?.status === 404
        ? { accepted: false, tiers: [] }
        : showDataPlus
      : { accepted: false, tiers: [] },
    availableTiers: hasUserAccess ? tiers : [],
    isLoading: plusDataLoading || permissionsLoading,
    error: plusDataError,
    setEpisodesTiers,
    hasAcastPlusBYOP,
  };
};
export default useAcastPlus;
